// Which trades can actually get an answer: a profession counts only if at least one verified,
// active professional lists it. notify-professionals-for-request sends to verified pros only,
// so a request in any other trade reaches nobody.

export const slugsWithSupply = (
  professions: Array<{ id: string; profession_id: string | null }>,
  pros: Array<{ profession_ids: string[] | null }>,
): Set<string> => {
  const covered = new Set(pros.flatMap(p => p.profession_ids ?? []));
  return new Set(professions.filter(p => p.profession_id && covered.has(p.id)).map(p => p.profession_id as string));
};

// Without supply data (the query failed) every option stays, as before.
export const keepWithSupply = <T extends { id: string; mainProfessionId?: string }>(options: T[], supplied: Set<string> | null): T[] =>
  supplied ? options.filter(o => supplied.has(o.mainProfessionId ?? o.id)) : options;
